import {IVehicle, Vehicle} from '@service-and-repairs/awpintegrationlib';
import {ConfigurationService} from '../configuration/services/configuration.service';
import {RotationImage} from './rotation-image';

export class CosyService {
  static readonly COSY_FALLBACK_IMAGE = 'COSY-EU-100-7331zK%25yoKGfl1w1pfag5EntUp6xEaS%25F6ds57Qqd';

  static addBasePathToCosyUrls(vehicle: IVehicle): IVehicle {
    // if there is no url set, just use a transparent PNG
    return Vehicle.fromPlainObject({
      ...vehicle,
      imageUrlSmall: CosyService.getCosyBaseUrl() +
        (vehicle.getImageUrlSmall() || CosyService.COSY_FALLBACK_IMAGE),
      imageUrlLarge: CosyService.getCosyBaseUrl() +
        (vehicle.getImageUrlLarge() || CosyService.COSY_FALLBACK_IMAGE),
      imageUrlInterior: CosyService.getCosyBaseUrl() +
        (vehicle.getImageUrlInterior() || CosyService.COSY_FALLBACK_IMAGE)
    });
  }

  static addBasePathToRotationImages(images: readonly RotationImage[]): readonly RotationImage[] {
    return images.map((image: RotationImage): RotationImage => ({
      angle: image.angle,
      imageUrl: CosyService.getCosyBaseUrl() + image.imageUrl
    }));
  }

  private static getCosyBaseUrl(): string {
    return ConfigurationService.getUrlForPortalHost('cosy');
  }
}
